import { Colors, Services, getPrice } from '@sigma-frontend-libs/commons'

import { components, icons } from '@/utils'

import { paymentStatusColors, paymentStatusIcons } from '@/components/services/payments/utils'
import sticker from '@/components/sticker'
import actions from '@/components/templates/service/item/actions'
import date from '@/components/templates/service/item/date'
import owner from '@/components/templates/service/item/owner'

function renderStatus(h) {
  let value
  let label
  if (this.viewport.size.width > 500) {
    value = this.getTranslate(`${Services.payments}.statuses.${this.value.status}`)
    label = this.getTranslate(`${Services.payments}.labels.status`)
  }

  return h(
    sticker,
    {
      props: {
        value,
        label,
        icon: paymentStatusIcons[this.value.status],
        iconTooltip: this.getTranslate(`${Services.payments}.statuses.${this.value.status}`),
        color: paymentStatusColors[this.value.status]
      }
    }
  )
}
function renderSum(h) {
  let label = this.getTranslate(`${Services.payments}.labels.amount`)
  if (this.viewport.breakpoint.xs) {
    label = this.value.Owner.username
  }

  return h(
    sticker,
    {
      props: {
        value: getPrice(this.value.amount, { currency: this.currency }),
        label,
        iconSVG: this.currency,
        color: Colors.grey
      }
    }
  )
}
function renderMethod(h) {
  if (this.viewport.size.width > 610) {
    return h(
      sticker,
      {
        props: {
          value: this.getTranslate(`${Services.payments}.methods.${this.value.method}`),
          label: this.getTranslate(`${Services.recurrentPayments}.labels.method`),
          iconSVG: this.value.method,
          iconTooltip: this.getTranslate(`${Services.payments}.methods.${this.value.method}`),
          color: Colors[this.value.method]
        }
      }
    )
  }
}
function renderOwner(h) {
  if (this.viewport.size.width > 820) {
    return h(
      owner,
      {
        props: {
          value: this.value
        }
      }
    )
  }
}
function renderInfo(h) {
  return h(
    'div',
    {
      class: {
        [`${Services.payments}-item__info`]: true,
        [`${Services.payments}-item__info--admin`]: this.canGetUsersAsResellerUp
      }
    },
    [
      renderStatus.call(this, h),
      renderSum.call(this, h),
      renderMethod.call(this, h),
      renderOwner.call(this, h)
    ]
  )
}

function renderPaymentLogsItem(h) {
  return h(
    components['list-item'],
    {
      props: {
        label: this.getTranslate(`${Services.payments}.buttons.paymentLogs`),
        icon: icons.history,
        dense: true
      },
      on: {
        click: () => {
          this.$emit('paymentLogs', this.value.id)
        }
      }
    }
  )
}
function renderBillingsItem(h) {
  return h(
    components['list-item'],
    {
      props: {
        label: this.getTranslate(`${Services.payments}.buttons.billings`),
        icon: icons.request_page,
        dense: true,
        disabled: !Array.isArray(this.value.Billings) || Array.isArray(this.value.Billings) && !this.value.Billings.length
      },
      on: {
        click: () => {
          this.$emit(Services.billings, this.value.Billings)
        }
      }
    }
  )
}
function renderActions(h) {
  if (this.canGetPaymentsAsAdmin) {
    return h(
      actions,
      {
        props: {
          value: this.value,
          service: Services.payments,
          actions: []
        }
      },
      [
        renderPaymentLogsItem.call(this, h),
        renderBillingsItem.call(this, h)
      ]
    )
  }
}

function renderCreatedAt(h) {
  return h(
    date,
    {
      props: {
        value: this.value
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: {
        ['service-template-item']: true,
        ['hover-parent hover-parent--opacity']: this.viewport.breakpoint.mdUp,
        [`${Services.payments}-item`]: true,
        [`${Services.payments}-item--admin`]: this.canGetPaymentsAsAdmin
      }
    },
    [
      renderInfo.call(this, h),
      renderActions.call(this, h),
      renderCreatedAt.call(this, h)
    ]
  )
}
